import { Link, useLocation } from "react-router-dom";
import { Flame } from "lucide-react";

export default function StickyCTA() {
  const { pathname } = useLocation();
  if (pathname === "/book-trial") return null;
  return (
    <div
      data-testid="sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 sticky-cta-safe bg-black/85 backdrop-blur-xl border-t border-[#ff4500]/30"
    >
      <Link to="/book-trial" className="block">
        <div className="flex items-center justify-center gap-2 py-4 bg-gradient-to-r from-[#ff4500] to-[#ffb700] text-black uppercase tracking-wider text-sm font-semibold">
          <Flame className="w-4 h-4" strokeWidth={2.2} /> Book Free Trial Class
        </div>
      </Link>
    </div>
  );
}
